import React, { useState } from 'react';
import { JarTipForm } from './JarTipForm';
import { JarTipHistory } from './JarTipHistory';

interface Props {
  tenantId: string;
  userEmail: string;
  isAdminOrManager: boolean;
}

export const JarTipContainer: React.FC<Props> = ({ tenantId, userEmail, isAdminOrManager }) => {
  const [activeTab, setActiveTab] = useState<'submit' | 'history'>('submit');

  return (
    <div className="space-y-6">
      <div className="flex border-b border-gray-200">
        <button
          className={`pb-2 px-4 font-semibold ${activeTab === 'submit' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500'}`}
          onClick={() => setActiveTab('submit')}
        >
          Submit Tip
        </button>
        <button
          className={`pb-2 px-4 font-semibold ${activeTab === 'history' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500'}`}
          onClick={() => setActiveTab('history')}
        >
          History
        </button>
      </div>
      {activeTab === 'submit' ? (
        <JarTipForm tenantId={tenantId} />
      ) : (
        <JarTipHistory tenantId={tenantId} userEmail={userEmail} isAdminOrManager={isAdminOrManager} />
      )}
    </div>
  );
};
